<template>
  <div class="main-layout">
    <CCollapseItem>
      <template slot="title-left"> 新生基本信息 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="批量导出个人登记表" @click="exportZip">
            <i
              class="iconfont icon-daochu1"
              :class="{ disabled: isExport }"
            ></i>
          </div>
          <div class="opt-btn" title="批量导出excel" @click="exportExcel">
            <i
              class="iconfont icon-daochu3"
              :class="{ disabled: isExport }"
              style="font-size: 26px"
            ></i>
          </div>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>
      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        @showDetail="goto"
        @export="handleExport"
        v-loading="pageLoading"
      >
      </c-table>
    </el-card>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import Configs from "./data/basic";
import { getOrgOptions } from "@/libs/searchSelect.js";
import exportHttp from "@/config/exportHttp.js";
import { mapState } from "vuex";
let mPage = MPage({
  pagePath: "/account/base/student/listPage?zxs=zxs",
  pageDelPath: "/account/base/student",
  pageDelsPath: "/account/base/student/delBatch",
  pageParams: {
    collegeId: "",
    grade: "",
    majorId: "",
    classId: "",
    classIdList: [],
    academicDegree: "",
    academicYear: "",
    studentNoOrName: "",
    sex: "",
    idCard: "",
    phoneNumber: "",
    enrollmentYear: "",
  },
  pageExportPath: "/account/base/student/exportExcel",
  pageExportParams: {},
});
export default {
  mixins: [mPage],
  data() {
    let { searchItems, tableColumns } = Configs(this);
    return {
      searchItems,
      tableColumns,
      isExport: false,
      idList: [],
    };
  },
  computed: {
    ...mapState("dic", [
      "SUCCESS_CODE",
      "_CURRENTYEAR",
      "_COLLEGE_ID",
      "_CURRENT_ACADEMIC",
      "_CURRENT_ACADEMIC",
    ]),
  },
  created() {
    this.setCollegeId();
  },
  mounted() {},
  methods: {
    setCollegeId() {
      if (this._COLLEGE_ID) {
        this.pageParams.collegeId = this._COLLEGE_ID;
        getOrgOptions(
          this,
          { parentId: this._COLLEGE_ID, type: "department" },
          1,
          null
        );
      }
    },
    goto(data) {
      let id = data.id;
      let studentId = data.studentId;
      let idCard = data.idCard;
      this.$router.push("/welcome/dataInit/basicDetail/" + studentId);
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.studentId);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    pageGetBeforeFn(data) {
      let params = Object.assign({}, data);
      if (!params.academicDegree)
        params.academicDegree = this._CURRENT_ACADEMIC;
      params.enrollmentYear = this._CURRENTYEAR[0].value;
      params.classId = params.classIdList.join(",");
      delete params.classIdList;
      return params;
    },
    refresh() {
      this.idList = [];
      this.searchItems[2].options = [];
      this.searchItems[3].options = [];
      this.pageParams = {
        collegeId: "",
        grade: "",
        majorId: "",
        classId: "",
        classIdList: [],
        academicDegree: "",
        academicYear: "",
        studentNoOrName: "",
        sex: "",
        idCard: "",
        phoneNumber: "",
        enrollmentYear: "",
      };
      this.setCollegeId();
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    handleExport(data) {
      // console.log(data);
      exportHttp
        .post("/account/base/student/exportForm/" + data.studentId)
        .then((res) => {
          console.log(res);
          if (res.data.code) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.warning("正在导出中！");
            console.log(res);
            let blob = new Blob([res.data], {
              type: `application/msword`, //word文档为msword,pdf文档为pdf
            });
            const link = document.createElement("a");
            let url = URL.createObjectURL(blob);
            link.href = url;
            link.download = decodeURIComponent(
              res.headers["content-disposition"].split("=")[1]
            );
            link.click();
            URL.revokeObjectURL(url);
            link.remove();
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    exportZip() {
      if (!this.idList.length)
        return this.$message.warning("请选择需要导出的学生！");
      if (this.isExport) {
        return;
      } else {
        this.isExport = true;
        this.message = this.$message({
          message: "数据正在导出中，请稍候！",
          duration: 0,
          type: "warning",
          center: true,
        });
        let params = { studentIdStr: this.idList.join() };
        exportHttp
          .post("/account/base/student/exportWordZip", params, {
            responseType: "blob",
          })
          .then((res) => {
            // console.log(res)
            const link = document.createElement("a");
            let url = URL.createObjectURL(res.data);
            link.href = url;
            link.download = decodeURIComponent(
              res.headers["content-disposition"].split("=")[1]
            );
            // link.download = filename ? filename : '导出数据.xls';
            link.click();
            URL.revokeObjectURL(url);
            link.remove();
            this.isExport = false;
            this.message.close();
            this.message = null;
            this.refresh();
          })
          .catch((err) => {
            this.isExport = false;
            this.message.close();
            this.message = null;
            console.warn(err);
          });
      }
    },
    exportExcel() {
      if (this.isExport) {
        return;
      } else {
        this.isExport = true;
        this.message = this.$message({
          message: "数据正在导出中，请稍候！",
          duration: 0,
          type: "warning",
          center: true,
        });
        let params = Object.assign({}, this.pageParams);
        if (!params.academicDegree)
          params.academicDegree = this._CURRENT_ACADEMIC;
        params.enrollmentYear = this._CURRENTYEAR[0].value;
        params.classId = params.classIdList.join();
        delete params.classIdList;
        this.pageExportParams = params;
        if (this.idList.length) {
          this.pageExportParams.studentIdStr = this.idList.join();
        }
        this.pageExport();
      }
    },
    pageExportAfterFn() {
      this.isExport = false;
      this.message.close();
      this.message = null;
      this.refresh();
      this.pageExportParams = {};
    },
  },
};
</script>
